import { useSelector } from "react-redux";
import useSubscribe from "../../../../../../custom-hooks/useSubscribe";
import { State } from "../../../../../../selectors/state";
import { valuesOf } from "../../../../../../shared-functions/objects";
import { ValidOpenstackResource } from "../../../../../types";

const useNetworkPorts = (network?: ValidOpenstackResource) => {
  useSubscribe("PORTS_LIST");

  const portsObject = useSelector((state: State) => state.ports);

  const ports = valuesOf(portsObject.PORTS_LIST).filter(
    (port) => port.network_id === network?.id,
  );

  const isLoading = portsObject.PORTS_LIST_LOADING_ZONES_LEFT > 0;

  return { ports, isLoading };
};

export default useNetworkPorts;
